import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import {Row,Col} from 'react-bootstrap';
import EarlyAccessBenefits from '../../Presale/IconBox/EarlyAccessBenefits';
import ExclusivePricing from '../../Presale/IconBox/ExclusivePricing';
import PotentialForGrowth from '../../Presale/IconBox/PotentialForGrowth';
import TrustAndTransparency from '../../Presale/IconBox/TrustAndTransparency'





const IconBox = () => {


  return (
    <div className='pt-4 pb-4'>
    <Row>
        <Col lg={3} md={6} xs={6}>
            <div className='icon_box'>
                <EarlyAccessBenefits/>
                <h4 className="text-uppercase"><b>Exclusive Pricing </b></h4>
            </div>
        </Col>
        <Col lg={3} md={6} xs={6}>
            <div className='icon_box'>
              <ExclusivePricing/>
                <h4 className="text-uppercase"><b>Early Access Benefits </b></h4>
            </div>
        </Col>
        <Col lg={3} md={6} xs={6}>
            <div className='icon_box'>
                <PotentialForGrowth/>
                <h4 className="text-uppercase"><b>Potential for Growth </b></h4>
            </div>
        </Col>
        <Col lg={3} md={6} xs={6}>
            <div className='icon_box'>
                <TrustAndTransparency/>
                <h4 className="text-uppercase"><b>Trust and Transparency </b></h4>
            </div>
        </Col>

    </Row>

</div>
  );
}

export default IconBox
